import { SUBJECT_HIT_ALPHA_THRESHOLD } from "../../utils/getBoundingBox";

export const ALPHA_HIT_THRESHOLD = 16;

export function buildAlphaMaskFromImage(image) {
  const canvas = document.createElement("canvas");
  const width = image.naturalWidth || image.width;
  const height = image.naturalHeight || image.height;
  canvas.width = width;
  canvas.height = height;
  const ctx = canvas.getContext("2d");
  ctx.drawImage(image, 0, 0);
  const imageData = ctx.getImageData(0, 0, width, height);
  return {
    width: imageData.width,
    height: imageData.height,
    data: imageData.data,
  };
}


export function sampleAlphaAtLocalPoint(hit, localX, localY, ow, oh) {
  const mask = hit.alphaMaskRef.current;
  const crop = hit.cropStateRef.current;
  const orig = hit.originalImageSizeRef.current;
  if (!mask || !crop.width || !crop.height || !orig.width || !orig.height) return null;
  const scaleX = mask.width / orig.width;
  const scaleY = mask.height / orig.height;
  const ix = Math.floor((crop.x + (localX / ow) * crop.width) * scaleX);
  const iy = Math.floor((crop.y + (localY / oh) * crop.height) * scaleY);
  if (ix < 0 || iy < 0 || ix >= mask.width || iy >= mask.height) return 0;
  return mask.data[(iy * mask.width + ix) * 4 + 3];
}

export function pointerTargetsObject(hit, canvasX, canvasY) {
  if (!hit.imageUrl) return false;
  const ow = hit.objectSizeRef.current.width;
  const oh = hit.objectSizeRef.current.height;
  const objectPositionNow = hit.objectPositionRef.current;
  const objectRotationNow = hit.objectRotationRef.current;
  const objectFlipNow = hit.objectFlipRef.current;
  const cx = objectPositionNow.x + ow / 2;
  const cy = objectPositionNow.y + oh / 2;
  const dx = canvasX - cx;
  const dy = canvasY - cy;
  const rad = (-objectRotationNow * Math.PI) / 180;
  const cos = Math.cos(rad);
  const sin = Math.sin(rad);
  const rx = dx * cos - dy * sin;
  const ry = dx * sin + dy * cos;
  const localX = rx / objectFlipNow.x + ow / 2;
  const localY = ry / objectFlipNow.y + oh / 2;
  if (localX < 0 || localY < 0 || localX > ow || localY > oh) return false;
  if (hit.objectTightBoundsRef.current) {
    if (hit.alphaMaskRef.current && !hit.alphaMaskFallbackRef.current) {
      const alpha = sampleAlphaAtLocalPoint(hit, localX, localY, ow, oh);
      if (alpha != null && alpha <= SUBJECT_HIT_ALPHA_THRESHOLD) return false;
    }
    return true;
  }
  if (hit.alphaMaskFallbackRef.current) return true;
  if (!hit.alphaMaskRef.current) return false;
  const alpha = sampleAlphaAtLocalPoint(hit, localX, localY, ow, oh);
  return alpha != null && alpha > SUBJECT_HIT_ALPHA_THRESHOLD;
}
